import Input from '../input'
import ReactSlider from '../../vendor/react-slider'
import css from './style.css'
import { Grid, GridItem } from '../grid'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import resetHiddenComponent from '../reset-hidden-components'

class Slider extends Component {
  constructor (props) {
    super(props)
    this.state = {
      value: props.value
    }
    this.minPos = this.props.mapValues ? this.props.mapValues.valToPos(this.props.min) : this.props.min
    this.maxPos = this.props.mapValues ? this.props.mapValues.valToPos(this.props.max) : this.props.max
  }

  toPos (value) {
    if (this.props.mapValues) {
      if (Array.isArray(value)) {
        return value.map(v => this.props.mapValues.valToPos(v))
      } else {
        return this.props.mapValues.valToPos(value)
      }
    }
    return value
  }

  toVal (position) {
    if (this.props.mapValues) {
      if (Array.isArray(position)) {
        return position.map(p => this.props.mapValues.posToVal(p))
      } else {
        return this.props.mapValues.posToVal(position)
      }
    }
    return position
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      value: nextProps.value
    })
  }

  trailingPeriod (value) {
    return /\.$/.test(value)
  }

  trailingZeroesAfterPeriod (value) {
    return /\.\d*0+$/.test(value)
  }

  validateInput (value) {
    return /^\d*\.?\d*$/.test(value)
  }

  // handle empty input, trailing period and trailing zeroes
  cleanInput (value) {
    if (value === '' || this.trailingPeriod(value) || this.trailingZeroesAfterPeriod(value)) {
      return value
    }
    return parseFloat(value)
  }

  onMoveSlider (position, sliderIndex) {
    if (Array.isArray(this.state.value)) {
      this.setState({
        value: [
          ...this.state.value.slice(0, sliderIndex),
          this.toVal(position[sliderIndex]),
          ...this.state.value.slice(sliderIndex + 1)
        ]
      })
    } else {
      this.setState({
        value: this.toVal(position)
      })
    }
  }

  onChangeSlider (position, sliderIndex) {
    if (Array.isArray(this.state.value)) {
      this.props.onChange([
        ...this.state.value.slice(0, sliderIndex),
        this.toVal(position[sliderIndex]),
        ...this.state.value.slice(sliderIndex + 1)
      ])
    } else {
      this.props.onChange(this.toVal(position))
    }
  }

  onChangeInputOne (e) {
    if (this.validateInput(e.target.value)) {
      const cleaned = this.cleanInput(e.target.value)
      const newValue = Array.isArray(this.props.value)
        ? [cleaned, this.props.value[1]]
        : cleaned

      this.props.onChange(newValue)
    }
  }

  onChangeInputTwo (e) {
    if (this.validateInput(e.target.value)) {
      const cleaned = this.cleanInput(e.target.value)
      const newValue = Array.isArray(this.props.value)
        ? [this.props.value[0], cleaned]
        : cleaned

      this.props.onChange(newValue)
    }
  }

  onBlurInputOne (e) {
    // Two inputs case, this being the minimum input
    if (Array.isArray(this.props.value)) {
      if (e.target.value === '' || e.target.value < this.props.min || e.target.value > this.props.value[1]) {
        this.props.onChange([this.props.min, this.props.value[1]])
      }
    } else {
      // Single input case
      if (e.target.value === '' || e.target.value < this.props.min) {
        this.props.onChange(this.props.min)
      } else if (e.target.value > this.props.max) {
        this.props.onChange(this.props.max)
      }
    }
  }

  onBlurInputTwo (e) {
    if (e.target.value === '' || e.target.value < this.props.value[0] || e.target.value > this.props.max) {
      const newValue = Array.isArray(this.props.value)
        ? [this.props.value[0], this.props.max]
        : this.props.max

      this.props.onChange(newValue)
    }
  }

  render () {
    const classNames = [
      'slider-container',
      this.props.single ? 'single' : '',
      this.props.double ? 'double' : '',
      this.props.inputs ? 'inputs' : '',
      this.props.input ? 'input' : '',
      this.props.className ? this.props.className : ''
    ]

    // come up with a nice value for the slider
    // in case our internal state is wonky
    const defaultMin = this.props.min || 0

    const prepValueForSlider = (val) => {
      // handle empty value in the input box
      if (val === '') {
        return defaultMin
      }

      // handle trailing period and trailing zeroes
      if (typeof (val) === 'string' && (this.trailingPeriod(val) || this.trailingZeroesAfterPeriod(val))) {
        return parseFloat(val)
      }

      return val
    }

    let sliderValue = this.state.value
    if (Array.isArray(sliderValue)) {
      sliderValue = sliderValue.map((val) => prepValueForSlider(val))
    } else {
      sliderValue = prepValueForSlider(sliderValue)
    }
    sliderValue = this.toPos(sliderValue)

    const markers = this.props.markers ? this.props.markers : []

    let inputValue = this.state.value

    return (
      <div>
        {this.props.label && <h4 id={this.props.labelId}>{this.props.label}</h4>}
        <div className={css.sliderRoot}>
          <div className={classNames.join(' ')}>
            <Grid>
              <GridItem col='1/1'>
                <ReactSlider
                  value={sliderValue}
                  onChange={this.onMoveSlider.bind(this)}
                  onAfterChange={this.onChangeSlider.bind(this)}
                  min={this.minPos}
                  max={this.maxPos}
                  step={markers.length ? this.maxPos / markers.length : this.props.step}
                  className='slider'
                  barClassName='slider-bar'
                  minDistance={this.props.minDistance || 1}
                  handleClassName='slider-handle'
                  withBars />
                <div className='markers'>
                  {markers.map((marker, i) => (
                    <div
                      key={i}
                      className='marker'
                      style={{width: `${100 / markers.length}%`, left: `${i / markers.length * 100}%`}}>
                      <span>{marker}</span>
                      <div className='border' />
                    </div>
                  ))}
                </div>
              </GridItem>
              <GridItem col='1/2'>
                <div className='input-1'>
                  {this.props.labelLeft ? <span className='label'>{this.props.labelLeft}&nbsp;</span> : ''}
                  <Input sm inline
                    inputId={`${this.props.sliderId}-input-1`}
                    onChange={this.onChangeInputOne.bind(this)}
                    onBlur={this.onBlurInputOne.bind(this)}
                    value={Array.isArray(inputValue) ? inputValue[0] : inputValue} />
                  {this.props.labelRight ? <span className='label'>&nbsp;{this.props.labelRight}</span> : ''}
                </div>
              </GridItem>
              <GridItem col='1/2' pullRight>
                <div className='input-2'>
                  {this.props.labelLeft ? <span className='label'>{this.props.labelLeft}&nbsp;</span> : ''}
                  <Input sm inline
                    inputId={`${this.props.sliderId}-input-2`}
                    onChange={this.onChangeInputTwo.bind(this)}
                    onBlur={this.onBlurInputTwo.bind(this)}
                    value={Array.isArray(inputValue) ? inputValue[1] : ''} />
                  {this.props.labelRight ? <span className='label'>&nbsp;{this.props.labelRight}</span> : ''}
                </div>
              </GridItem>
            </Grid>
          </div>
        </div>
      </div>
    )
  }
}

Slider.PropTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number,
  minDistance: PropTypes.number.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onMove: PropTypes.func,
  double: PropTypes.bool,
  input: PropTypes.bool,
  inputs: PropTypes.bool,
  markers: PropTypes.array,
  labelLeft: PropTypes.string,
  labelRight: PropTypes.string,
  mapValues: PropTypes.shape({
    valToPos: PropTypes.func,
    posToVal: PropTypes.func
  })
}

export default resetHiddenComponent(Slider)



// WEBPACK FOOTER //
// ./src/components/slider/index.js